import React from 'react';
import { Helmet } from 'react-helmet';

const ProductSchema = ({ products }) => {
  if (!products || products.length === 0) return null;

  const productSchemas = products.map(product => ({
    "@type": "Product",
    "name": product.title || product.name,
    "description": product.description || `${product.title || product.name} - качественный строительный материал от Карат-сервис`,
    "image": product.image ? `https://store-be1e1.web.app${product.image}` : "https://store-be1e1.web.app/images/logo.svg",
    "brand": {
      "@type": "Brand",
      "name": product.brand || "Карат-сервис"
    },
    "offers": {
      "@type": "Offer",
      "price": product.price,
      "priceCurrency": "BYN",
      "availability": "https://schema.org/InStock",
      "seller": {
        "@type": "Organization",
        "name": "Карат-сервис"
      }
    },
    "category": product.category || "Строительные материалы"
  }));

  const schemaData = {
    "@context": "https://schema.org",
    "@type": "ItemList",
    "itemListElement": productSchemas.map((product, index) => ({
      "@type": "ListItem",
      "position": index + 1,
      "item": product
    }))
  };

  return (
    <Helmet>
      <script type="application/ld+json">
        {JSON.stringify(schemaData)}
      </script>
    </Helmet>
  );
};

export default ProductSchema;
